export default "__VITE_ASSET__yvXyotog__"